export enum BluebookStatus {
  Active = 'active',
  Both = 'active-archived',
  Inactive = 'inactive',
}
